import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { BaseWebService } from '../../../services/base-web.service';
import 'rxjs/add/observable/throw';

@Injectable()
export class PhoneFollowUpPopupService {
    constructor(
        private _baseWebService: BaseWebService
    ) { }

    makeContact(id: any, type: string) {
        const data: any = {};
        let url: string;

        switch(type) {
            case 'follow-up':
                url = 'followup_communications/';
                break;
            case 'non-start-follow-up':
                url = 'non_start_followup_communications/';
                break;
            case 'parent-follow-up':
                url = 'parent_relapse_communications/';
                break;
            case 'patient-follow-up':
                url = 'patient_relapse_communications/';
                break;
            case 'referral':
                url = 'patient_referral/';
                break;
            case 'vc-follow-up':
                url = 'va/vc_followup/';
                break;
        }

        data.body = {
            method: 'phone'
        };

        return this._baseWebService.request("v1/" + url + id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
      * Function for handling service call errors
      * @param  {Response|any} error contains error data
      */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}